/*
 * Application Insights JavaScript SDK - Performance Mark and Measure Manager plugin, 3.2.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
/**
* PerfMarkMeasureManager.ts
* @copyright Microsoft 2021
*/
import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims";
import dynamicProto from "@microsoft/dynamicproto-js";
import { PerfManager, getPerformance, getSetValue } from "@microsoft/applicationinsights-core-js";
import { _DYN_MEASURE } from "./__DynamicConstants";
// Names used in the perf Event context
var strCtxMarkName = "prf-mark";
var strCtxMarkEndName = "prf-mark-end";
var strCtxMeasureName = "prf-measure";
var PerfMarkMeasureManager = /** @class */ (function (_super) {
    __extends(PerfMarkMeasureManager, _super);
    function PerfMarkMeasureManager(config, manager) {
        var _this = _super.call(this, manager) || this;
        var _config = config || {};
        var _uniqueId = 0;
        // Set any defaults that have not been defined
        getSetValue(_config, "useMarks", true);
        getSetValue(_config, "markPrefix", "ai.prfmrk.");
        getSetValue(_config, "useEndMarks", false);
        getSetValue(_config, "markEndPrefix", "ai.prfmrk-end.");
        getSetValue(_config, "useMeasures", true);
        getSetValue(_config, "measurePrefix", "ai.prfmsr.");
        dynamicProto(PerfMarkMeasureManager, _this, function (_self, _base) {
            var _perf = getPerformance();
            _self.create = function (src, payloadDetails, isAsync) {
                var perfEvent = _base.create(src, payloadDetails, isAsync);
                if (perfEvent) {
                    var markName = _getMarkName(perfEvent);
                    if (markName) {
                        _perf.mark(markName);
                    }
                }
                return perfEvent;
            };
            _self.fire = function (perfEvent) {
                if (perfEvent) {
                    var mrkEndName = null;
                    if (_config.useEndMarks === true) {
                        mrkEndName = perfEvent.getCtx(strCtxMarkEndName);
                        if (mrkEndName) {
                            _perf.mark(mrkEndName);
                        }
                    }
                    var measureName = perfEvent.getCtx(strCtxMeasureName);
                    if (measureName) {
                        var mrkName = perfEvent.getCtx(strCtxMarkName);
                        if (mrkName) {
                            if (mrkEndName) {
                                _perf[_DYN_MEASURE /* @min:%2emeasure */](measureName, mrkName, mrkEndName);
                            }
                            else {
                                _perf[_DYN_MEASURE /* @min:%2emeasure */](measureName, mrkName);
                            }
                        }
                        else {
                            if (mrkEndName) {
                                _perf[_DYN_MEASURE /* @min:%2emeasure */](measureName, undefined, mrkEndName);
                            }
                            else {
                                _perf[_DYN_MEASURE /* @min:%2emeasure */](measureName);
                            }
                        }
                    }
                    _base.fire(perfEvent);
                }
            };
        });
        function _getMarkName(perfEvent) {
            var mrkName = null;
            var postFix = "";
            if (_config.uniqueNames) {
                postFix = _uniqueId + ".";
                _uniqueId++;
            }
            if (_config.useMarks) {
                var mappedName = _getMappedName(_config.markNameMap, perfEvent.name);
                if (mappedName) {
                    mrkName = (_config.markPrefix || "") + postFix + mappedName;
                    perfEvent.setCtx(strCtxMarkName, mrkName);
                    if (_config.useEndMarks === true) {
                        var mrkEndName = (_config.markEndPrefix || "") + postFix + mappedName;
                        perfEvent.setCtx(strCtxMarkEndName, mrkEndName);
                    }
                }
            }
            if (_config.useMeasures) {
                var measureName = null;
                var mappedName = _getMappedName(_config.measureNameMap || _config.markNameMap, perfEvent.name);
                if (mappedName) {
                    measureName = (_config.measurePrefix || "") + postFix + mappedName;
                    perfEvent.setCtx(strCtxMeasureName, measureName);
                }
            }
            return mrkName;
        }
        function _getMappedName(map, name) {
            var mappedName = name;
            if (map) {
                // A map exists
                mappedName = map[name];
            }
            return mappedName;
        }
        return _this;
    }
// Removed Stub for PerfMarkMeasureManager.prototype.create.
// Removed Stub for PerfMarkMeasureManager.prototype.fire.
    // This is a workaround for an IE bug when using dynamicProto() with classes that don't have any
    // non-dynamic functions or static properties/functions when using uglify-js to minify the resulting code.
    PerfMarkMeasureManager.__ieDyn=1;

    return PerfMarkMeasureManager;
}(PerfManager));
export { PerfMarkMeasureManager };
//# sourceMappingURL=PerfMarkMeasureManager.js.map